import twopoolSwapABI from './json/2pool/swap';

const multicall_address = '0xb828c456600857abd4ed6c32facc607bd0464f4f';

const poolsData = {
    '2pool': {
        swap_abi: twopoolSwapABI,
        N_COINS: 2,
        coin_precisions: [1e18, 1e6],
        wrapped_precisions: [1e18, 1e6],
        tethered: [false, false],
        use_lending: [false, false],
        is_plain: [true, true],
        swap_address: '0x27e611fd27b276acbd5ffd632e5eaebec9761e40',
        token_address: '0x27e611fd27b276acbd5ffd632e5eaebec9761e40',
        underlying_coins: [
            '0x8d11ec38a3eb5e956b052f67da8bdc9bef8abf3e',
            '0x04068da6c83afcfa0e13ba15a6696662335d5b75',
        ],
        coins: [
            '0x8d11ec38a3eb5e956b052f67da8bdc9bef8abf3e',
            '0x04068da6c83afcfa0e13ba15a6696662335d5b75',
        ],
    },
};

export {
    multicall_address,
    poolsData,
};
